import backofficeService from '../../api/backoffice'

export default {
  /**
   * 📨 Start a chat or get existing conversation
   * @param {*} data { targetUserId, profileId }
   */
  startChat(data) {
    return backofficeService
      .Api()
      .post('chat/start', data)
      .then((res) => res.data)
      .catch((err) => {
        throw err
      })
  },

  /**
   * 💬 Get all conversations for logged-in user
   * @param {*} params { limit, offset }
   */
  getAll(params = {}) {
    return backofficeService
      .Api()
      .get('chat', { params })
      .then((res) => res.data)
      .catch((err) => {
        throw err
      })
  },

  /**
   * 💭 Get messages of a specific conversation
   * @param {*} conversationId
   * @param {*} params
   */
  getMessages(conversationId, params = {}) {
    return backofficeService
      .Api()
      .get(`chat/${conversationId}/messages`, { params })
      .then((res) => res.data)
      .catch((err) => {
        throw err
      })
  },

  /**
   * ✉️ Send a new message
   * @param {*} conversationId
   * @param {*} data { toUserId, content }
   */
  sendMessage(conversationId, data) {
    return backofficeService
      .Api()
      .post(`chat/${conversationId}/send`, data)
      .then((res) => res.data)
      .catch((err) => {
        throw err
      })
  },

  /**
   * ✅ Mark all messages as read in a conversation
   * @param {*} conversationId
   */
  markAsRead(conversationId) {
    return backofficeService
      .Api()
      .put(`chat/${conversationId}/read`)
      .then((res) => res.data)
      .catch((err) => {
        throw err
      })
  },

  /**
   * 🔍 Get specific conversation by ID
   * @param {*} conversationId
   */
  getById(conversationId) {
    return backofficeService
      .Api()
      .get(`chat/${conversationId}`)
      .then((res) => {
        console.log("🗨️ Chat getById result:", res.data); // 👈 logs full response data
        return res.data; // still returns the data to your Vue component
      })
      .catch((err) => {
        console.error("❌ Error fetching chat by ID:", err); // helpful debug log
        throw err;
      });
  },
}